import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=317077a2&scoped=true&"
import script from "./RemindPassword.vue?vue&type=script&lang=js&"
export * from "./RemindPassword.vue?vue&type=script&lang=js&"
import style0 from "./RemindPassword.vue?vue&type=style&index=0&id=317077a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317077a2",
  null
  
)

export default component.exports